import styled from 'styled-components';

export const HeroLeftWrapper = styled.div`
  position: absolute;
  bottom: -150px;
  left: -150px;

  ${(props) => props.theme.breakpoints.down('md')} {
    left: -250px;
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 200px;
    left: -50px;
    bottom: -50px;
  }
`;

export const HeroRightWrapper = styled.div`
  position: absolute;
  bottom: -200px;
  right: -50px;
  transform: rotate(-45deg);

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100px;
    right: 0;
    bottom: -80px;
  }
`;

export const VeganLeftWrapper = styled.div`
  position: absolute;
  bottom: -20px;
  left: 0px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 300px;
    left: 0px;
  }
`;

export const VeganRightWrapper = styled.div`
  position: absolute;
  bottom: -10px;
  right: 0px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 300px;
    right: -30px;
  }
`;

export const FingerFoodLeftWrapper = styled.div`
  position: absolute;
  bottom: -20px;
  left: -50px;
  transform: rotate(15deg);
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 300px;
    left: -120px;
    bottom: -0px;
  }
`;

export const FingerFoodRightWrapper = styled.div`
  position: absolute;
  bottom: -10px;
  right: -10px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 200px;
    right: -60px;
    bottom: -30px;
  }
`;

export const CocktailLeftWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 220px;
    bottom: 0;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 150px;
  }
`;

export const CocktailRightWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 220px;
    bottom: 0;
    right: 0;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 150px;
  }
`;

export const BaseLeftWrapper = styled.div`
  position: absolute;
  bottom: -50px;
  left: -50px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 220px;
    bottom: -45px;
    left: -45px;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 200px;
  }
`;

export const BaseRightWrapper = styled.div`
  position: absolute;
  bottom: -50px;
  right: -50px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 220px;
    bottom: -35px;
    right: -35px;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 200px;
  }
`;

export const FoodTruckLeftWrapper = styled.div`
  position: absolute;
  bottom: -10px;
  left: -10px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 220px;
    bottom: 0px;
    left: 0px;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 200px;
  }
`;

export const FoodTruckRightWrapper = styled.div`
  position: absolute;
  bottom: -100px;
  right: -100px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 220px;
    bottom: -35px;
    right: -35px;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 150px;
  }
`;

export const CoffebarRightWrapper = styled.div`
  position: absolute;
  bottom: -20px;
  right: 0px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 200px;
    bottom: 0;
    right: 0;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 150px;
  }
`;
